import React from "react";

import { Icon, Spinner } from "@blueprintjs/core";

import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import StarSVG from "@/../../hypetrain/static/img/star.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { roundToOneDecimalPlace } from "@/components/pages_logged_in/program/components/utils";

function StatCard({
  title,
  value,
  icon,
  subtitle,
}: {
  title: string;
  value: string;
  icon: React.ReactNode;
  subtitle?: string;
}) {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        padding: "24px",
        border: "1px solid #E2E2E2",
        flex: 1,
      }}
    >
      <Box
        css={{
          fontSize: 16,
          color: "#778397",
          marginBottom: "8px",
        }}
      >
        {title}
      </Box>
      <Flex
        css={{
          alignItems: "center",
          gap: 6,
        }}
      >
        {icon}
        <Flex flexDirection="row" style={{ gap: 6 }} alignItems="center">
          <Box css={{ fontSize: 32, fontWeight: 600 }}>{value}</Box>
          {subtitle && (
            <Box css={{ fontSize: 16, color: "#394B59" }}>{subtitle}</Box>
          )}
        </Flex>
      </Flex>
    </div>
  );
}

export function OneOneSessionStats({
  totalParticipants,
  onTrackPercentage,
  averageRating,
  completedSessionsCount,
  totalCreditsSpent,
  activeCoachesCount,
  ratingCount,
}: {
  totalParticipants: number;
  onTrackPercentage: number;
  averageRating: number;
  completedSessionsCount: number;
  totalCreditsSpent: number;
  activeCoachesCount: number;
  ratingCount: number;
}) {
  return (
    <div>
      <Flex
        css={{
          gap: "24px",
          flexWrap: "wrap",
          marginBottom: "24px",
        }}
      >
        <StatCard
          title="Total Participants"
          value={totalParticipants?.toString() || "0"}
          icon={<Icon icon="people" color="#778397" size={24} />}
        />
        <StatCard
          title="On Track"
          value={roundToOneDecimalPlace(onTrackPercentage || 0, "%")}
          icon={
            <Spinner
              value={(onTrackPercentage || 0) / 100}
              intent="success"
              size={24}
            />
          }
        />
        <StatCard
          title="Average Rating"
          value={averageRating ? roundToOneDecimalPlace(averageRating) : "-"}
          subtitle={`(${ratingCount})`}
          icon={<EmbedSvg src={StarSVG} height={24} width={24} />}
        />
      </Flex>
      <Flex
        css={{
          gap: "24px",
          flexWrap: "wrap",
        }}
      >
        <StatCard
          title="Completed Sessions"
          value={completedSessionsCount?.toString() || "0"}
          subtitle="Sessions"
          icon={null}
        />
        <StatCard
          title="Total Credits Spent"
          value={roundToOneDecimalPlace(totalCreditsSpent || 0)}
          icon={<EmbedSvg src={CreditSVG} height={24} width={24} />}
        />
        <StatCard
          title="Active Coaches"
          value={activeCoachesCount?.toString() || "0"}
          icon={<Icon icon="people" color="#778397" size={24} />}
        />
      </Flex>
    </div>
  );
}
